export { default } from './IssueTable';
